import { openApiForEditing } from "../../designer-view-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const apiTools: ToolHandlerGroup = {
  sync: {
    ui_project_list_apis: () => {
      const sd = getSdInstance();
      const apis = sd.projectProvider.getProject()?.apiManagements;
      if (!apis) return { apis: [], count: 0 };

      const parseApiJson = (json: string | undefined): { methods?: unknown[] } => {
        if (!json) return {};
        try {
          return JSON.parse(json) as { methods?: unknown[] };
        } catch {
          return {};
        }
      };

      const list = apis.map((api) => ({
        id: api.id,
        name: api.name,
        methodCount: parseApiJson(api.json).methods?.length || 0
      }));

      return { count: list.length, apis: list };
    },

    ui_project_get_api_details: (input) => {
      const { apiId } = input;
      if (!apiId) return { error: "apiId is required" };

      const sd = getSdInstance();
      const api = sd.projectProvider.getProject()?.apiManagements?.find((a) => a.id === apiId);
      if (!api) return { error: `API "${apiId}" not found` };

      interface ApiMethodRaw {
        id?: string;
        name?: string;
        httpMethod?: string;
        method?: string;
        url?: string;
        endpoint?: string;
      }
      let parsed: { methods?: ApiMethodRaw[] } = {};
      if (api.json) {
        try {
          parsed = JSON.parse(api.json) as { methods?: ApiMethodRaw[] };
        } catch {
          parsed = {};
        }
      }
      const methods = (parsed.methods || []).map((m) => ({
        id: m.id,
        name: m.name,
        httpMethod: m.httpMethod || m.method,
        url: m.url || m.endpoint
      }));

      return {
        id: api.id,
        name: api.name,
        methodCount: methods.length,
        methods
      };
    }
  },

  async: {
    ui_project_navigate_to_api: async (input) => {
      const { apiId, methodId } = input;
      if (!apiId) return { error: "apiId is required" };

      const sd = getSdInstance();
      const api = sd.projectProvider.getProject()?.apiManagements?.find((a) => a.id === apiId);
      if (!api) return { error: `API "${apiId}" not found` };

      await openApiForEditing(sd, apiId, {
        ensureView: true,
        methodId
      });

      return {
        success: true,
        message: `Opened API "${api.name}" for editing`
      };
    }
  }
};
